'use strict'

import {SERVER_API_URL} from './ServerConstant';
export const API_URL = SERVER_API_URL;

// eslint-disable-next-line prefer-const
export const
  TOKEN_NAME = 'kidsToken',
  USER_DETAILS = 'kidsUser',
  PREFIX = 'kids/',
  LOGIN = PREFIX + 'login',
  SSO_LOGIN = PREFIX + 'sso-login',
  LOGOUT = PREFIX + 'logout',

  IMPERSONATOR_TOKEN_NAME = 'ikidsToken',
  IMPERSONATOR_USER_DETAILS = 'ikidsUser',
  IMPERSONATOR_LOGOUT = 'ikidsLogout',
  IMPERSONATOR_USERS = PREFIX + 'impersonate/users',
  IMPERSONATOR_USER = PREFIX + 'impersonate',

  GET_KEYS = PREFIX + 'getKeys',
  KEYS_VESSEL = PREFIX + 'getVesselKeys',
  KEYS_EMAIL = PREFIX + 'getEmailKeys',
  EMAIL_LISTS = PREFIX + 'getEmailLists',
  ADD_EMAIL = PREFIX + 'addEmail',
  DELETE_EMAIL = PREFIX + 'deleteEmail',
  UPDATE_EMAIL = PREFIX + 'updateEmailById/{email_id}',
  EMAIL_BY_ID = PREFIX + 'getEmailById/{email_id}',
  UPDATE_EMAIL_MODULE_FEATURE = PREFIX + 'updateEmailModuleFeature/{email_id}/{module_feature_id}',

  KEYS_MODULE = PREFIX + 'getModuleKeys',

  KEYS_COUNTRY = PREFIX + 'getCountryKeys',
  KEYS_TIMEZONE = PREFIX + 'getTimezoneKeys',
  KEYS_REPORT_STATUS = PREFIX + 'getReportStatusKeys',
  KEYS_MNGMT_OFFICE = PREFIX + 'getMngmtOfficeKeys',
  KEYS_MNGMT_OFFICE_VESSELS = PREFIX + 'getMngmtOfficeVesselsKeys',
  KEYS_CREW = PREFIX + 'getCrewKeys',
  KEYS_USER = PREFIX + 'getUserKeys',
  KEYS_USER_RANKS = PREFIX + 'getUserRanksKeys',
  KEYS_EVENT_ONE = PREFIX + 'getEventOneKeys',
  KEYS_EVENT_TWO = PREFIX + 'getEventTwoKeys',
  KEYS_EVENT_THREE = PREFIX + 'getEventThreeKeys',
  KEYS_EVENT_FOUR = PREFIX + 'getEventFourKeys',
  KEYS_EVENT_FIVE = PREFIX + 'getEventFiveKeys',
  KEYS_MAIN_CAUSE = PREFIX + 'getMainCauseKeys',
  KEYS_SUB_CAUSE = PREFIX + 'getSubCauseKeys',
  KEYS_MNGMT_COMPANY = PREFIX + 'getMngmtCompanyKeys',
  KEYS_FLEET = PREFIX + 'getFleetKeys',
  KEYS_VESSEL_TYPES = PREFIX + 'getVesselTypeKeys',
  KEYS_EVENT_IMPACT = PREFIX + 'getEventClassImpactKeys',

  KEYS_HERROR_PERSONALS = PREFIX + 'getHErrorPersonalKeys',
  KEYS_HERROR_MANNINGS = PREFIX + 'getHErrorManningKeys',
  KEYS_HERROR_OTHERS = PREFIX + 'getHErrorOtherKeys',

  GET_CURRENCIES = PREFIX + 'getCurrencies',
  API_CURRENCY = PREFIX + 'currency',


  ACCIDENT_INCIDENT = PREFIX + 'accidentIncidentReport',
  ACCIDENT_INCIDENT_CHART_DATA = PREFIX + 'accidentIncidentChartData',
  ACCIDENT_INCIDENT_IMMEDIATE_CAUSE_CHART_DATA = PREFIX + 'accidentIncidentImmediateCauseChartData',
  ACCIDENT_INCIDENT_ROOT_CAUSE_CHART_DATA = PREFIX + 'accidentIncidentRootCauseChartData',
  ACCIDENT_INCIDENT_CHART_BY_EVENT_DATA = PREFIX + 'accidentIncidentByEvent',
  ACCIDENT_INCIDENT_MORE_THAN_24HRS = PREFIX + 'accident-incident/more-than-24hrs/list',
  ACCIDENT_INCIDENT_MORE_THAN_24HRS_EXPORT = PREFIX + 'accident-incident/more-than-24hrs/export',
  // Base for Loss > Personnel > Add Crew's Medical Reports - the full paths are built in
  // ReportService: `${ACCIDENT_INCIDENT_MEDICAL_REPORTS}/{report}/linkable-medical-reports` and /link-medical-report.
  ACCIDENT_INCIDENT_MEDICAL_REPORTS = PREFIX + 'accident-incident',
  AIR_EVENT=PREFIX + 'accidentIncidentEvent',
  AIR_LOSS=PREFIX + 'accidentIncidentLoss',
  AIR_CAUSE= PREFIX + 'accidentIncidentCause',
  AIR_PREVENTIVE= PREFIX + 'accidentIncidentPreventive',
  AIR_CORRECTIVE= PREFIX+ 'accidentIncidentCorrective',
  CMS_ONBOARD_CREW = PREFIX + 'getOnboardCrew',
  CMS_VESSELS_WITH_ONBOARD_CREWS = PREFIX + 'getAllVesselsWithOnBoardCrews',
  CMS_VESSELS_WITH_CURRENT_ONBOARD_CREWS = PREFIX + 'getAllVesselsWithCurrentOnBoardCrews',
  CMS_ONBOARD_CREW_NATIONALITY_STATS = PREFIX + 'getOnboardCrewNationalityStats',
  CMS_NATIONALITY_LIST = PREFIX + 'getCmsCrewNationality',
  CMS_CREW_INFO=PREFIX + 'getCrewInfo',
  CMS_CREW_ACTIVITIES=PREFIX + 'getCrewActivities',
  CMS_CREW_IMAGE= PREFIX + 'getCrewImage',
  CMS_CREW_CONSENT= PREFIX + 'getCrewConsent',
  CMS_CREW_BIODATA= PREFIX + 'getCrewBiodata',
  CMS_SEA_EXPERIENCE=PREFIX + 'getCrewExperience',
  CMS_OUTSIDE_EXPERIENCE=PREFIX + 'getCrewExternalExperience',
  CMS_INCIDENT_BEHAVIOR= PREFIX + 'getCrewIncidentBehavior',
  CMS_INCIDENT_BEHAVIOR_FILE=PREFIX + 'getCrewIncidentBehaviorFile',
  CMS_CREW_DOCUMENTS=PREFIX + 'getCrewDocuments',
  CMS_CREW_FLAG_DOCUMENTS=PREFIX + 'getCrewDocumentsByFlag',
  CMS_CREW_ASSESSMENTS_REPORT=PREFIX + 'getAssessments',
  CMS_CREW_ASSESSMENT_HISTORY=PREFIX + 'getAssessmentHistory',
  CMS_CREW_ASSESSMENT_FILE = PREFIX + 'getAssessmentFile',
  CMS_CREW_DOCUMENT_HISTORY=PREFIX + 'getCrewDocumentHistory',
  CMS_CREW_DOCUMENT_FILE=PREFIX + 'getCrewDocumentFile',
  CMS_MEDICAL_KEYS= PREFIX + 'getMedicalKeys',
  CMS_CREW_MEDICALS=PREFIX + 'getCrewMedicals',
  CMS_CREW_HEALTH_DECLARATIONS=PREFIX + 'getHealthDeclarations',
  CMS_CREW_RT_PCR=PREFIX + 'getCrewRtPcr',
  CMS_CREW_VACCINE=PREFIX + 'getCovidVaccines',
  CMS_CREW_MEDICAL_FILE=PREFIX + 'getCrewMedicalFile',
  CMS_CREW_VACCINE_FILE=PREFIX + 'getCovidVaccineFile',
  CMS_RT_PCR_FILE=PREFIX + 'getRtpcrTestFile',
  CMS_HEALTH_DECLARATION_FILE=PREFIX + 'getHealthDeclarationFile',
  CMS_CREW_CERS=PREFIX + 'getCrewEvaluationReports',
  CMS_CER_FILE=PREFIX + 'getCrewEvaluationFile',
  CMS_CER_COMMENT_ATTACHMENT=PREFIX + 'getCrewCommentAttachment',
  CMS_COMPANY_EVALUATIONS=PREFIX + 'getCompanyEvaluations',
  CMS_COMPANY_EVALUTAION_FILE=PREFIX + 'getCompanyEvaluationFile',
  CMS_CREW_MEDICAL_ISSUES=PREFIX + 'getMedicalIssues',
  CMS_CREW_PANDI=PREFIX + 'getPandIs',
  CMS_CREW_PANDI_CHECKUP_FILE=PREFIX + 'getPandICheckupAttachment',
  CMS_CREW_PANDI_EXPENSE_FILE=PREFIX + 'getPandiExpenseAttachment',
  CMS_CREW_MEDICAL_INCIDENT_FILE=PREFIX + 'getMedicalIncidentFile',
  CMS_CREW_MEDICAL_INJURY_FILE=PREFIX + 'getMedicalInjuryFile',
  CMS_CREW_MEDICAL_HOSPITALIZATION_FILE=PREFIX + 'getMedicalHospitalizationFile',
  CMS_CREW_AGE_AND_RANK_STATS = PREFIX + 'getCrewAgeAndRankStats',
  CMS_CREW_BASED_ON_AGE_AND_RANK_LIST = PREFIX + 'getCrewBasedOnAgeAndRank',
  CMS_CREW_EMBARK_DISEMBARK_HISTORY_LIST = PREFIX + 'getCrewEmbarkDisembarkHistory',
  CMS_COUNTRIES_LIST = PREFIX + 'getCountries',
  CMS_PORTS_LIST = PREFIX + 'getPorts',
  CMS_RANKS_LIST = PREFIX + 'getRanks',
  CMS_ALL_VESSEL_MANNING_COMPANY = PREFIX + 'getAllVesselManningCompany',
  EXPORT_CREW_HISTORY = PREFIX + 'exportCrewHistory',


  AIR_LOSS_DELETE_PERSONEL= PREFIX + 'removePersonnel',
  REPORT = PREFIX + 'report',
  ACCIDENT_INCIDENT_ATTACHMENTS=PREFIX + 'accidentIncidentAttachment',
  INTERNAL_AUDIT_ATTACHMENTS = PREFIX + 'internalAuditAttachment',
  CORRECTIVE_ACTION_ATTACHMENTS = PREFIX + 'correctiveActionAttachment',
  ACCIDENT_INCIDENTS_STATUS_HISTORY=PREFIX + 'accidentIncidentStatusHistoryLogs',
  ACCIDENT_INCIDENTS_LIST_REPORT=PREFIX + 'accidentIncidentListReport',

  //ACCIDENT_INCIDENT = PREFIX + 'accidentIncident',
  // ACCIDENT_INCIDENT_GENERAL = PREFIX + 'fillGeneralDetails',
  // ACCIDENT_INCIDENT_EVENT = PREFIX + 'fillEventDetails',
  // ACCIDENT_INCIDENT_CAUSE = PREFIX + 'fillCauseDetails',
  // ACCIDENT_INCIDENT_CORRECT_ACTION = PREFIX + 'fillCorrectActionDetails',
  // ACCIDENT_INCIDENT_PREVENT_ACTION = PREFIX + 'fillPreventActionDetails',
  // ACCIDENT_INCIDENT_FEEDBACK = PREFIX + 'fillFeedbackDetails',
  // ACCIDENT_INCIDENT_LOSS = PREFIX + 'fillLossDetails',
  // ACCIDENT_INCIDENT_VIEW_ATTACHMENT= PREFIX + 'getAccidentIncidentAttachment',
  // ACCIDENT_INCIDENT_VIEW_ATTACHMENTS= PREFIX + 'getAccidentIncidentAttachments',
  // DELETE_INCIDENT_ACCIDENT_ATTACHMENT= PREFIX + 'deleteAccidentIncidentAttachment',
  // DOWNLOAD_ACCIDENT_INCIDENT_ATTACHMENT= PREFIX + 'downloadAllAttachments',
  VESSEL_MANAGEMENT = PREFIX + 'vesselManagement',
  VESSEL_SHIPBUILDER_DATA = PREFIX + 'getVesselShipBuilderData',
  VESSEL_SHIPBUILDER_LIST = PREFIX + 'getVesselShipBuilderList',
  DOWNLOAD_SUMMARY_MANAGING_VESSEL = PREFIX + 'downloadSummaryOfManagingVessel',
  PRINT_SUMMARY_MANAGING_VESSEL_GRAPH = PREFIX + 'printSummaryOfManagingVesselGraph',
  VESSEL_LIST = PREFIX + 'getVesselList',
  VESSELS_AUDIT_SCHEDULE = PREFIX + 'vessels/audit/schedule',
  SUMMARY_VESSEL_LIST = PREFIX + 'getVesselSummaryList',
  VESSEL_DETAIL = PREFIX + 'getVesselDetail',
  VESSEL_FILE = PREFIX + 'vessels/{vessel_id}/file',
  VESSEL_VISITATION = PREFIX + 'vessels/{vessel_id}/visitations',
  VESSEL_SMS_RECORD = PREFIX + 'vessels/{vessel_id}/sms-records',
  VESSEL_DOWNLOAD_ALL_FILE = PREFIX + 'vessels/{vessel_id}/file/download-all',
  UPLOAD_VESSEL_FILE = PREFIX + 'vessels/{vessel_id}/file/upload',
  UPLOAD_VESSEL_VISITATION = PREFIX + 'vessels/{vessel_id}/visitations/upload',
  UPLOAD_VESSEL_SMS_RECORD = PREFIX + 'vessels/{vessel_id}/sms-records/upload',
  VESSEL_INFO = PREFIX + 'getVesselInfo',
  ADD_VESSEL = PREFIX + 'addVessel',
  UPDATE_VESSEL = PREFIX + 'updateVessel',
  DELETE_VESSEL = PREFIX + 'deleteVessel',
  DOWNLOAD_VESSEL_LIST = PREFIX + 'downloadVessel',

  VESSEL_ACCIDENT_INCIDENT_YEARLY_COUNTS = PREFIX + 'ships-pi/accident-incident/yearly/counts',
  DOWNLOAD_VESSEL_ACCIDENT_INCIDENT_YEARLY_COUNTS = PREFIX + 'ships-pi/accident-incident/yearly/counts/download',
  VESSEL_ACCIDENT_INCIDENT_YEARLY_COUNTS_LIST = PREFIX + 'ships-pi/accident-incident/yearly/counts/list',
  VESSEL_ACCIDENT_INCIDENT_WORKING_ENVIRONMENT = PREFIX + 'ships-pi/working-environment',
  VESSEL_PSC_DEFICIENCIES = PREFIX + 'ships-pi/psc-inspection/deficiency',
  VESSEL_PSC_DEFICIENCIES_EXPORT = PREFIX + 'ships-pi/psc-inspection/deficiency/export',
  VESSEL_PSC_INSPECTION_EXPORT = PREFIX + 'ships-pi/psc-inspection/inspection/export',
  VESSEL_PSC_INSPECTIONS = PREFIX + 'ships-pi/psc-inspection/number-inspection',
  VESSEL_RIGHTSHIP_INSPECTIONS = PREFIX + 'ships-pi/rightship-inspection/number-inspection',

  DELETE_REPORT = PREFIX + 'deleteReport',
  // ADD_ACCIDENT_INCIDENT_ATTACHMENT=PREFIX + 'addAccidentIncidentAttachments',
  ADD_CA_FILE = PREFIX + 'addCAFiles',
  GET_CA_FILES = PREFIX + 'getCAFiles',
  DOWNLOAD_CA_FILES = PREFIX + 'downloadCAFile',
  DELETE_CA_FILE = PREFIX + 'deleteCAFile',
  DOWNLOAD_CA_FILES_ALL = PREFIX + 'downloadCAFileAll',
  GET_MANNING_KEYS = PREFIX + 'getManningKeys',

  ALL_USERS = PREFIX + 'users',
  CREATE_USER = PREFIX + 'users',
  UPDATE_USER = PREFIX + 'users',
  USER_VESSEL = PREFIX + 'user/{user_id}/vessels',
  UPDATE_USER_ROLE_PERMISSIONS = PREFIX + 'updateRolePermission',
  PERMISSION_KEYS = PREFIX + 'getRolePermissionKeys',
  STATIC_PERMISSION_KEYS = PREFIX + 'getStaticPermissionKeys',

  COMPANY_INSTRUCTION = PREFIX +  'comp-in',
  COMPANY_INSTRUCTION_CANCEL = PREFIX +  'cancelInstruction',
  COMPANY_INSTRUCTION_EXPORT = PREFIX + 'company-instructions/{ci_id}/export',
  SENT_TO_VESSEL = PREFIX +  'sendToVessel',
  VESSEL_INSTRUCTION_LIST = PREFIX + 'vesselCompInstruction',
  VESSEL_INSTRUCTION_RESPONSE = PREFIX + 'airCiVesselResponse',
  VESSEL_INSTRUCTION_FILES = PREFIX + 'getCiVesselFiles',
  VESSEL_INSTRUCTION_ADD_FILES = PREFIX + 'addCiVesselFiles',
  VESSEL_INSTRUCTION_VIEW_FILE= PREFIX + 'getCiFile',
  VESSEL_INSTRUCTION_DELETE_FILE= PREFIX + 'deleteCIAttachment',
  DOWNLOAD_CA_REPORT = AIR_CORRECTIVE + '/downloadReport',
  UPDATE_REPORT_STATUS= PREFIX + 'updateReportStatus',
  DOWNLOAD_AI_REPORT= PREFIX + 'accident-incident/{report_id}/download',
  DOWNLOAD_CREW_EXPERIENCE_LIST= PREFIX + 'exportCrewList',
  DOWNLOAD_AI_REPORT_TEMPLATE= PREFIX + 'accident-incident/download/template/{vessel_id}',
  UPLOAD_AI_REPORT=PREFIX + 'accident-incident/import',
  GENERATE_AIR_VESSEL_HISTORY=PREFIX + 'vessel/history',

  GET_SISTER_SHIP_GROUPS=PREFIX + 'getVesselGroups',
  ADD_SISTER_SHIP_GROUP=PREFIX + 'addVesselGroup',
  DELETE_SISTER_SHIP_GROUP=PREFIX + 'deleteVesselGroup',
  UPDATE_SISTER_GROUP=PREFIX + 'updateVesselGroup',
  GET_SISTER_VESSEL_INFO=PREFIX + 'getSisterVesselInfo',
  RELATED_PARTY = PREFIX + 'relatedParty',
  RELATED_PARTY_VESSEL_IDS = PREFIX + 'relatedPartyVesselIds',
  RELATED_PARTIES = PREFIX + 'relatedParties',
  CI_SAVE_SUBMIT_VESSEL = PREFIX + 'saveAndSubmitVessel',
  CI_TYPE_KEYS = PREFIX + 'getCompanyInstructionKeys',
  KEY_MEDICAL_SEVERITY = PREFIX + 'getMedicalSeverityKeys',
  KEY_MEDICAL_TREATMENT = PREFIX + 'getMedicalTreatmentKeys',
  KEY_AILMENT_PART = PREFIX + 'getAilmentPartKeys',
  KEY_AILMENT = PREFIX + 'getAilmentKeys',
  KEY_MEDICAL_TYPE = PREFIX + 'getMedicalTypeKeys',
  KEY_AILMENT_REASON = PREFIX + 'getAilmentReasonKeys',

  ADD_LOSS_PERSONNEL = PREFIX + 'addPersonnel',
  PERSONNEL_ATTACHMENTS = PREFIX + 'getPersonnelAttachments',
  DELETE_PERSONNEL_ATTACHMENT = PREFIX + 'deletePersonnelAttachment',
  GET_PERSONNEL_ATTACHMENT= PREFIX + 'downloadPersonnelAttachment',
  AIR_REPORT_STATUS_COUNTS= PREFIX + 'getDashboardCounts',
  RS_REPORT_STATUS_COUNTS= PREFIX + 'getRsDashboardCounts',
  AIR_CHARTS= PREFIX + 'getAccidentCharts',
  RS_CHARTS= PREFIX + 'getRsCharts',
  AIR_SAFETY_AND_HEALTH_CHARTS_DATA= PREFIX + 'getAccidentSafetyAndHealthChartsData',
  VESSEL_ACCIDENT_INCIDENT_LOSS_REPORT= PREFIX + 'getDashboardAccidentIncidentLossReport',
  AIR_YEARLY_SUMMARY= PREFIX + 'getAirYearlySummaryByModule/{module}',
  FLEET_CONTACT_LIST= PREFIX + 'downloadContactList',
  FLEET_CONTACT_LIST_DATE= PREFIX + 'getContactListDate',
  GET_FLEET_CONTACT_LISTS= PREFIX + 'getFleetContactLists',
  DELETE_FLEET_CONTACT_LIST_BY_NAME= PREFIX + 'deleteFleetContactListByName',
  UPLOAD_FLEET_CONTACT_LIST= PREFIX + 'uploadFleetContactList',
  GET_CONTACT_FILE = PREFIX + 'getSpecificFleetContactListByName',

  CHANGE_PASSWORD= PREFIX + 'changePassword',
  RESET_PASSWORD= PREFIX + 'resetPassword',
  MANAGING_VESSEL = PREFIX + 'managing-vessel',
  MANAGING_VESSEL_HISTORY_LOGS = PREFIX + 'history-logs',
  ENGINE_MAKER=PREFIX + 'engine-maker',
  ENGINE_TYPE=PREFIX + 'engine-type',
  ENGINE_DG_MAKER=PREFIX + 'engine-dg-maker',
  ENGINE_DG_TYPE=PREFIX + 'engine-dg-type',
  ENGINE_TC_MAKER=PREFIX + 'engine-tc-maker',
  ENGINE_TC_TYPE=PREFIX + 'engine-tc-type',
  ENGINE_AUX_MAKER=PREFIX + 'engine-aux-maker',
  ENGINE_AUX_TYPE = PREFIX + 'engine-aux-type',
  GET_ACCIDENT_INCIDENT_BY_EVENT= PREFIX + 'getAccidentIncidentByEvent',
  GET_INSPECTION_BY_FINDING= PREFIX + 'getInspectionsByFinding',
  GET_INSPECTION_BY_INSPECTOR_FINDING= PREFIX + 'getInspectionsByInspectorFinding',
  GET_FINDING_BY_PORTS_FINDING= PREFIX + 'getFindingsByPortsFinding',
  PSC_INDEX = PREFIX + 'psc',
  PSC_CODES = PREFIX + 'psc-codes',
  PSC_ACTION_CODES = PREFIX + 'psc-action-codes',
  PSC_USCG_CODES = PREFIX + 'psc-uscg-codes',
  JOB_STATUSES = PREFIX + 'job-status',
  ACKNOWLEDGEMENT_STATUSES = PREFIX + 'acknowledgement-status',
  CI_INDEX = PREFIX + 'ci',
  CI_VESSEL_INDEX = PREFIX + 'ci-vessel',
  CI_VESSEL_ATTACHMENT = PREFIX + 'ci-vessel-attachment',
  CI_COMMENT_INDEX = PREFIX + 'ci-comment',
  DOWNLOAD_PSC_REPORT= PREFIX + 'psc/{report_id}/export/report',
  DOWNLOAD_PSC_REPORT_TEMPLATE= PREFIX + 'psc/{vessel_id}/export/template',
  UPLOAD_PSC_REPORT_TEMPLATE= PREFIX + 'psc/import',
  PSC_REPORT_INDEX= PSC_INDEX + '/reports',
  DOWNLOAD_PSC_MONTHLY_SUMMARY = PSC_INDEX + '/report/download-monthly-summary',
  GENERATE_PSC_VESSEL_HISTORY=PSC_INDEX + '/vessel/history',
  MATCH_ROUTE_NAMES = {
    pscid: 'PscMain',
  },

  RS_INDEX = PREFIX + 'rs',
  RS_CODES = PREFIX + 'rs-codes',
  RS_ACTION_CODES = PREFIX + 'rs-action-codes',
  DOWNLOAD_RS_REPORT= PREFIX + 'rs/{report_id}/export/report',
  DOWNLOAD_RS_REPORT_TEMPLATE= PREFIX + 'rs/{vessel_id}/export/template',
  UPLOAD_RS_REPORT_TEMPLATE= PREFIX + 'rs/import',
  RS_REPORT_INDEX= RS_INDEX + '/reports',
  GENERATE_RS_VESSEL_HISTORY=RS_INDEX + '/vessel/history',
  RS_RCA= RS_INDEX + '/get/rca',
  RS_DOWNLOAD_REPORT= RS_INDEX + '/download-list',
  // RS_RCA_DOWNLOAD = RS_INDEX + '/rca/download',

  RSNC = PREFIX + 'rsnc',
  RSNC_QUESTION_KEYS= PREFIX + 'rsnc-question',

  // AUDITOR MODULE CONSTANTS
  USER_FOR_AUDITOR = PREFIX + 'auditors/users/{user_id}',
  AUDITS = PREFIX + 'audits',
  AUDITS_SETTINGS = PREFIX + 'audits/settings',
  VESSEL_AUDITS = PREFIX + 'vessels/{vessel_id}/audits',
  GENERATE_AUDIT_VESSEL= PREFIX + 'audits/vessel/download',
  AUDITOR_INDEX = PREFIX + 'audits/auditors',
  AUDITOR_CERTIFICATE = PREFIX + 'audits/certificates',
  AUDITOR_DEPARTMENTS = PREFIX + 'auditors/departments',
  AUDITOR_POSITIONS = PREFIX + 'auditors/positions',
  AUDITOR_AUDIT_HISTORY = PREFIX + 'auditors/audit-history/{auditor_id}',

  DELETE_AUDIT_FILE = PREFIX + 'audits/{audit_id}/{type}',

  // IA REPORTS CONSTANTS
  IA_REPORTS_BY_TYPE = PREFIX + '{type}/{id}/ia-reports',
  DIRECTOR_SECURITY = PREFIX + '{type}/{id}/getDirectorSecurity',
  DESIGNATED_PERSON = PREFIX + 'getDesignatedPerson',
  UPDATE_IA_REPORT_TYPE_BY_ID = PREFIX + 'ia-reports/{audit_report}',
  DELETE_ATTENDANCE = PREFIX + 'ia-reports/{audit_report}/attendance',
  DELETE_CHECKLIST = PREFIX + 'ia-reports/{audit_report}/checklist',
  DELETE_MASTER_SIGNATURE = PREFIX + 'ia-reports/{audit_report}/master-signature',
  DOWNLOAD_DOCUMENT = PREFIX + 'vessel-audits/{audit_id}/{audit_type}/downloads',
  DOWNLOAD_STATUS_HISTORY = PREFIX + 'vessel-audits/download-status-history',

  // NON CONFORMITIES CONSTANTS

  ROOT_CAUSES_LIST = PREFIX + 'audits/{type}/root-causes',
  NON_CONFORMITIES = PREFIX + '{type}/{id}/non-conformities',
  NON_CONFORMITIES_ORDER = PREFIX + '{type}/{id}/non-conformities/order',
  UPDATE_NON_CONFORMITIES = PREFIX + 'non-conformities/{non_conformity}',
  DELETE_NON_CONFORMITY = PREFIX + 'non-conformities/{non_conformity}',
  NON_CONFORMITIES_OE = PREFIX + 'non-conformities/{non_conformity}/objective-evidences',

  // NCR OBJECTIVE EVIDENCE CONSTANTS
  LATEST_OBJECTIVE_EVIDENCES = PREFIX + 'objective-evidences',
  OE_CATEGORIES_LIST = PREFIX + 'objective-evidences/categories',
  UPDATE_OBJECTIVE_EVIDENCE = PREFIX + 'objective-evidences/{objective_evidence}',
  DELETE_OBJECTIVE_EVIDENCE = PREFIX + 'objective-evidences/{objective_evidence}',

  OE_BEFORE_ATTACHMENTS = PREFIX + 'objective-evidences/{objective_evidence}/before',
  OE_AFTER_ATTACHMENTS = PREFIX + 'objective-evidences/{objective_evidence}/after',

  // APPOINTMENT DETAILS CONSTANTS
  GET_IA_APPOINTMENT_DETAILS_BY_TYPE_AND_ID = PREFIX + '{type}/{id}/ia-appointment-details',
  UPDATE_IA_APPOINTMENT_DETAILS = PREFIX + 'ia-appointment-details/{ia_appointment_report}',


  // VPI CONSTANTS
  VPI = PREFIX + 'vpi',
  UPDATE_ICBT_SCORE = PREFIX + 'vessels/{vessel}/icbt-score',

  // AUDIT DUES

  AUDIT_DUES = PREFIX + 'audit-dues',
  AUDIT_DUES_DOWNLOAD = PREFIX + 'audit-dues/download',
  AUDIT_DUE_COUNTS = PREFIX + 'audits-due/counts',
  AUDIT_DUE_PLAN = PREFIX + 'vessels/{vessel}/audit-due-plan',
  AUDIT_DUE_APPOINTMENT_DETAILS = PREFIX + 'audit-dues/appointment-details',

  //COMPANY AUDIT CONSTANTS
  COMPANIES = PREFIX + 'companies',
  COMPANY = PREFIX + 'companies/{company_id}',

  COMPANY_AUDITS = PREFIX + 'company/audits',
  COMPANY_AUDITS_BY_ID = PREFIX + 'companies/{company_id}/audits',

  COMPANY_LATEST_OBJECTIVE_EVIDENCES = PREFIX + 'company/objective-evidences',
  COMPANY_AUDIT_DUES = PREFIX + 'company/audit-dues',
  COMPANY_AUDIT_DUE_COUNTS = PREFIX + 'company/audits-due/counts',

// IA REPORTS CONSTANTS
  COMPANY_IA_REPORTS_BY_TYPE = PREFIX + 'company/{type}/{id}/ia-reports',
  COMPANY_UPDATE_IA_REPORT_TYPE_BY_ID = PREFIX + 'company/ia-reports/{audit_report}',
  COMPANY_DOWNLOAD_DOCUMENT = PREFIX + 'company-audits/{audit_id}/{audit_type}/downloads',


  // NON CONFORMITIES CONSTANTS

  COMPANY_NON_CONFORMITIES = PREFIX + 'company/{type}/{id}/non-conformities',
  COMPANY_UPDATE_NON_CONFORMITIES = PREFIX + 'company/non-conformities/{non_conformity}',
  COMPANY_DELETE_NON_CONFORMITY = PREFIX + 'company/non-conformities/{non_conformity}',
  COMPANY_NON_CONFORMITIES_OE = PREFIX + 'company/non-conformities/{non_conformity}/objective-evidences',

  // NCR OBJECTIVE EVIDENCE CONSTANTS
  COMPANY_UPDATE_OBJECTIVE_EVIDENCE = PREFIX + 'company/objective-evidences/{objective_evidence}',
  COMPANY_DELETE_OBJECTIVE_EVIDENCE = PREFIX + 'company/objective-evidences/{objective_evidence}',

  COMPANY_OE_BEFORE_ATTACHMENTS = PREFIX + 'company/objective-evidences/{objective_evidence}/before',
  COMPANY_OE_AFTER_ATTACHMENTS = PREFIX + 'company/objective-evidences/{objective_evidence}/after',

  ANNOUNCEMENT = PREFIX + 'announcements',
  UPDATE_ANNOUNCEMENT = PREFIX + 'announcements/{id}',
  ACTIVE_ANNOUNCEMENT = PREFIX + 'announcements/active',
  SHOW_ANNOUNCEMENT = PREFIX + 'announcements/{id}',
  DELETE_ANNOUNCEMENT = PREFIX + 'announcements/{id}/delete',

  FILE_POND_PROCESS = PREFIX + 'filepond/process',
  FILE_POND_REVERT = PREFIX + 'filepond/revert',
  FILE_POND_RESTORE = PREFIX + 'filepond/restore',
  FILE_POND_LOAD = PREFIX + 'filepond/load',

  // REVISION NUMBER RIGHT SHIP QUESTIONNAIRES

  SHOW_QUESTIONNAIRE_REVISION = PREFIX + 'questionnaires/revision/{id}',
  QUESTIONNAIRE = PREFIX + 'questionnaires',
  UPDATE_QUESTIONNAIRE = PREFIX + 'questionnaires/{id}',
  SHOW_QUESTIONNAIRE = PREFIX + 'questionnaires{id}',
  DELETE_QUESTIONNAIRE = PREFIX + 'questionnaires/{id}/delete',
  DELETE_QUESTIONNAIRE_PASS = PREFIX + 'questionnaires/{id}/confirm-delete',

  REVISION = PREFIX + 'revisions',
  SHOW_NONCONFORMITY_REVISION = PREFIX + 'revisions/non-conformity/{id}',
  UPDATE_REVISION = PREFIX + 'revisions/{id}',
  SHOW_REVISION = PREFIX + 'revisions/{id}',
  DELETE_REVISION = PREFIX + 'revisions/{id}/delete',
  DELETE_REVISION_PASS = PREFIX + 'revisions/{id}/confirm-delete',

  INSPECTORS = PREFIX + 'inspectors/list',
  SHOW_INSPECTOR = PREFIX + 'inspectors/{id}',
  SHOW_COMPANY_INSPECTOR = PREFIX + 'inspectors-company/{id}',
  SHOW_RIGHTSHIP_REPORT = PREFIX + 'inspectors-company/rightship',
  GET_RIGHTSHIP_CHART_DATA = PREFIX + 'getRsInspectorCharts',
  GET_RIGHTSHIP_FINDING_DATA = PREFIX + 'getRsInspectorByFinding',
  CREATE_INSPECTOR = PREFIX + 'inspectors/create',
  UPDATE_INSPECTOR = PREFIX + 'inspectors/update/{id}',
  // DELETE_INSPECTOR = PREFIX + 'inspectors/delete/{id}',
  DELETE_INSPECTOR_PASS = PREFIX + 'inspectors/delete/{id}',
  RESTORE_INSPECTOR = PREFIX + 'inspectors/restore/{id}',

  INSPECTORS_COMPANIES = PREFIX + 'inspectors/company/list',
  SHOW_INSPECTOR_COMPANIES = PREFIX + 'inspectors/company/{id}',
  CREATE_INSPECTOR_COMPANIES = PREFIX + 'inspectors/company/create',
  UPDATE_INSPECTOR_COMPANIES = PREFIX + 'inspectors/company/update/{id}',
  DELETE_INSPECTOR_COMPANIES_PASS = PREFIX + 'inspectors/company/delete/{id}',
  RESTORE_INSPECTOR_COMPANIES = PREFIX + 'inspectors/company/restore/{id}',

  SHOW_RIGHTSHIP_REPORT_BY_PORTS = PREFIX + 'findings-by-port/rightship',
  GET_RIGHTSHIP_CHART_DATA_BY_PORTS = PREFIX + 'getRsFindingChartsByPorts',

  SHIP_BUILDERS = PREFIX + 'ship_builders/list',
  SHOW_SHIP_BUILDER = PREFIX + 'ship_builders/{id}',
  CREATE_SHIP_BUILDER = PREFIX + 'ship_builders/create',
  UPDATE_SHIP_BUILDER = PREFIX + 'ship_builders/update/{id}',
  DELETE_SHIP_BUILDER = PREFIX + 'ship_builders/delete/{id}',


  // ANSWERS - INTERNAL AUDIT CHECKLIST
  AUDIT_ANSWERS = PREFIX + 'ia/checklists/answers',
  AUDIT_DOWNLOAD_TEMPLATE = PREFIX + 'exportInternalAuditCheckList',
  AUDIT_IMPORT_CHECKLIST = PREFIX + 'importInternalAuditCheckList',
  AUDIT_DOWNLOAD_CHECKLIST_REPORT = PREFIX + 'exportInternalAuditCheckListReport',

  // SETTINGS - INTERNAL AUDIT CHECKLIST
  AUDIT_CHECKLIST = PREFIX + 'ia/checklists/settings',


  // FILTER MENU DATA REQUEST

  FILTER_MENU = PREFIX + 'filter-menu',


  // constants for exchange rates settings

  EXCHANGE_RATES = PREFIX + 'exchange-rates',
  EXCHANGE_RATES_EXPORT_TEMPLATE = PREFIX + 'exchange-rates/export-template',
  EXCHANGE_RATES_IMPORT_TEMPLATE = PREFIX + 'exchange-rates/import-template',
  EXCHANGE_RATES_CURRENCIES = PREFIX + 'exchange-rates-currencies',
  // OPEN AI REQUEST
  AI_SUMMARY = PREFIX + 'open_ai/getAiSummary',
  ELITE_AI_SUMMARY = PREFIX + 'assistants/images/summarize',
  ELITE_AI_CHAT = PREFIX + 'assistants/chat',
  PRINT_AI_SUMMARY = PREFIX + 'open_ai/getAiSummary/print',

  // OPEN AI PER REPORT
  AI_MODULE_QUERY = PREFIX + 'ai/{module}/query',
  AI_MODULE_REPORT = PREFIX + 'ai/{module}/report',
  AI_DOWNLOAD_RESULT_DATA = PREFIX + 'ai/download-data',
  AI_LOGS = PREFIX + 'ai/logs',
  AI_CHAT_COMPLETIONS = PREFIX + 'open_ai/completions',


  // KIDS V2 ENDPOINT

  KIDS_V2_SSO_TOKEN = PREFIX + 'generate-sso-token'
;
